<script>
export default {
	name: 'ScriptExecutor',
	inheritAttrs: false,
};
</script>
 
<script setup>
import { isMobileViewport } from '~/logic/composables/breakpoints.js';
 
const containerRef = ref(null);
const styles = [];
const scripts = [];
 
const props = defineProps({
	description: { type: String, default: '' },
	isHideInDesktop: { type: Boolean, default: false },
	isHideInMobile: { type: Boolean, default: false },
});
 
onMounted(() => {
	if (!containerRef.value || !document.querySelector('.script-executor-container')) return;
	if (!props.description.trim()) return;
 
	try {
		const parser = new DOMParser();
		const doc = parser.parseFromString(props.description, 'text/html');
 
		Array.from(doc.body.childNodes).forEach((node) => {
			containerRef.value.appendChild(node.cloneNode(true));
		});
 
		doc.querySelectorAll('style').forEach((style) => {
			const newStyle = document.createElement('style');
			newStyle.textContent = style.textContent;
			document.body.appendChild(newStyle);
			styles.push(newStyle);
		});
 
		doc.querySelectorAll('script').forEach((script) => {
			const newScript = document.createElement('script');
			if (script.src) {
				newScript.src = script.src;
			} else {
				newScript.textContent = script.textContent;
			}
			document.body.appendChild(newScript);
			scripts.push(newScript);
		});
	} catch (err) {
		console.error('Error while injecting HTML:', err);
	}
});
 
onUnmounted(() => {
	styles.forEach((s) => s.remove());
	scripts.forEach((s) => s.remove());
});
</script>
 
<template>
<div
	v-if="(isMobileViewport && !isHideInMobile) || (!isMobileViewport && !isHideInDesktop)"
	ref="containerRef"
	class="script-executor-container"
></div>
</template>